import { NgModule, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA, APP_INITIALIZER, ErrorHandler, LOCALE_ID } from '@angular/core';

import { HTTP_INTERCEPTORS, HttpClient, HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { SharedHandlersService } from './shared/shared-handlers.service';
import { userPermissionsService } from './shared/userPermissions.service';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { MatDialogModule } from '@angular/material/dialog';
import { ToastrModule } from 'ngx-toastr';
import { JwtModule } from "@auth0/angular-jwt";
import { DialogsModule } from '@progress/kendo-angular-dialog';


import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { LoginComponent } from './login/login.component';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { AuthService } from './core/auth.service';
import { ShareDataService } from './shared/services/ShareDateService';
import { BuildPreCachedURlsService } from './shared/services/BuildPre-CachedURLs.service';
import { MessageService } from '@progress/kendo-angular-l10n';
import { HomeComponent } from './home/home.component';
import { ChartsModule } from '@progress/kendo-angular-charts';
import { AdminRouteGuard } from './core/admin-route.guard';
import { UnauthorizedComponent } from './home/unauthorized.component';
import { UploadModule } from 'BI-Libraries/BI-Components/node_modules/@progress/kendo-angular-upload';
// import { AgmCoreModule, LAZY_MAPS_API_CONFIG } from '@agm/core';
import { GoogleMapsConfig } from './shared/services/GoogleMapsConfigService';
import { Ng2SearchPipeModule } from 'ng2-search-filter';
import { DatePipe, DecimalPipe } from '@angular/common';
// import { MessageErrorPipe } from './shared/pipes/messageError.pipe';
import { NgHttpLoaderModule } from 'ng-http-loader';
import { ErrorIntercept } from './core/error.interceptor';
import { BIModulesModule, CreateDialog } from 'bi-modules';
import { ICON_SETTINGS } from '@progress/kendo-angular-icons';
import { MatSidenavModule } from '@angular/material/sidenav';
import { TokenInterceptor } from './core/Interceptor/token-interceptor.interceptor';
import { GlobalErrorHandler } from './core/Services/globel-error-handler.service';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { IntlService } from '@progress/kendo-angular-excel-export';
import { CldrIntlService } from '@progress/kendo-angular-intl';
import { FilterModule } from "@progress/kendo-angular-filter";
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MessageErrorPipe } from './shared/Pipes/messageError.pipe';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { AreaPageComponent } from './area-page/area-page.component';
import { TreeViewModule } from "@progress/kendo-angular-treeview";
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { LoadingPageComponent } from './loading-page/loading-page.component';
import { LoginFormComponent } from './login-form/login-form.component';
import { SelectBUFormComponent } from './select-buform/select-buform.component';
import { GridModule } from '@progress/kendo-angular-grid';
import { ConversationalUIModule } from "@progress/kendo-angular-conversational-ui";
import { MatRadioModule } from '@angular/material/radio';
import { DataSourceService } from './shared/services/DataSourceServices/DataSource.service';
import { ChangeSetService } from './shared/services/DataSourceServices/ChangeSet.service';
import { IndicatorsModule } from "@progress/kendo-angular-indicators";
import { AppConfigService } from './reactive-forms/services/app-config.service';
import { NotificationComponent } from './reactive-forms/components/notification/notification.component';
import { MykendoLoader } from './reactive-forms/components/KendoLoader/KendoLoader';
import { MenuComponent } from './reactive-forms/components/menu/menu.component';
import { DashboardComponent } from './reactive-forms/components/dashboard/dashboard.component';
import { LinegraphComponent } from './reactive-forms/components/linegraph/linegraph.component';
import { HttpClientJsonpModule } from '@angular/common/http';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { LanguageSelectComponent } from './login/language-select/language-select.component';
import { ChatNavBarComponent } from './shared/chat-nav-bar/chat-nav-bar.component';
import { AboutComponent } from './about/about.component';
import { RequestLicenseDialogComponent } from './about/request-license-dialog/request-license-dialog.component';
import { ScreensListComponent } from './home/screens-list/screens-list.component';
const appInitializerConfig = (appConfig: AppConfigService) => {
  return () => {
    return appConfig.loadAppConfig();
  };
};

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, "./assets/i18n/", '.json');
}
@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    HomeComponent,
    UnauthorizedComponent,
    MessageErrorPipe,
    MenuComponent,
    ChangePasswordComponent,
    AreaPageComponent,
    LoadingPageComponent,
    LoginFormComponent,
    SelectBUFormComponent,
    NotificationComponent,
    MykendoLoader,
    ChatNavBarComponent,
    DashboardComponent,
    LinegraphComponent,
    LanguageSelectComponent,
    AboutComponent,
    RequestLicenseDialogComponent,
    ScreensListComponent,
  ],
  imports: [
    FilterModule,
    BrowserModule,
    FormsModule,
    MatDialogModule,
    DialogsModule,
    HttpClientModule,
    BrowserAnimationsModule,
    DropDownsModule,
    MatIconModule,
    MatTooltipModule,
    NgbModule,
    AppRoutingModule,
    NgHttpLoaderModule.forRoot(),
    ChartsModule,
    UploadModule,
    // Ng2SearchPipeModule,
    ReactiveFormsModule,

    MatSnackBarModule,
    // AgmCoreModule.forRoot({
    //   libraries: ['places']
    // }),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    ToastrModule.forRoot({
      timeOut: 10000,
      progressBar: true,
    }),
    JwtModule.forRoot({
      config: {
        tokenGetter: (request) => {
          if (request.url.includes("OData")) {
            return localStorage.getItem("ODataToken");
          }
          return localStorage.getItem("jwt");
        },
        allowedDomains: ["localhost:56653"],
        disallowedRoutes: []
      }
    }),
    BIModulesModule,
    MatSidenavModule,
    MatSlideToggleModule,
    TreeViewModule,
    MatRadioModule,
    IndicatorsModule,
    HttpClientJsonpModule
  ],
  providers: [
    AppConfigService,
    userPermissionsService,
    SharedHandlersService,    
    AdminRouteGuard,
    {
      provide: APP_INITIALIZER, useFactory: appInitializerConfig, multi: true, deps: [AppConfigService],
    },
    // { provide: LAZY_MAPS_API_CONFIG, useClass: GoogleMapsConfig },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorIntercept,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true
    },
    // {
    //   provide: UrlSerializer,
    //   useClass: LowerCaseUrlSerializer
    // },
    {
      provide: ErrorHandler,
      useClass: GlobalErrorHandler
    },


    AuthService,
    ShareDataService,
    BuildPreCachedURlsService,
    MessageService,
    DecimalPipe,
    DatePipe,
    { provide: ICON_SETTINGS, useValue: { type: 'font' } },
    {
      provide: IntlService,
      useExisting: CldrIntlService,
    },

    {
      provide: LOCALE_ID,
      useValue: 'en-US'
    },
    CldrIntlService,
    {
      provide: 'datasource',
      useFactory: () =>
        () => new DataSourceService(),
      deps: []
    },
    {
      provide: 'changeset',
      useFactory: () =>
        () => new ChangeSetService(),
      deps: []
    },
    {
      provide: 'CreateDialog',
      useFactory: () =>
        () => new CreateDialog(),
      deps: []
    },
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],

})
export class AppModule { }
